module.exports = __webpack_public_path__ + "static/mariana-489be865bc8aa31b45752fa22a68c689.png";